
<template>
    <div>
        <div class="head-text" @click.stop>
            <div class="head-row">
                <div class="head-logo" @click="toHome">
                    <img src="../assets/logo.png" alt="">
                </div>
                <div class="navigation">
                    <div class="navigation-heng"></div>
                    <div class="data-url">
                        <div class="data-ulr-details" v-for="item in dataList" :key="item.id" @click="linkto(item.url,item.id)"
                            :class="activeUrl == item.id ? 'data-ulr-details-active' : ''" @mouseenter="serhover(item.id)">
                            {{item.name}}
                            <div class="data-ulr-details-heng"></div>
                        </div>
                    </div>
                    <!-- TODO 暂时隐藏勿删 语言切换 -->
                    <!-- <div class="language">
                        <div class="zh" @click="languageChange('zh')" :class="language == 'zh' ? 'language-active' : ''">ZH</div>
                        <div>/</div>
                        <div class="en" @click="languageChange('en')" :class="language == 'en' ? 'language-active' : ''">EN</div>
                    </div> -->
                    <!-- 几个小图标的位置 -->
                    <div class="icon-row" :class="{'auto':searchShow}">
                        <div class="input-box">
                            <el-autocomplete
                                class="inline-input"
                                v-model="inputVal"
                                :fetch-suggestions="querySearch"
                                placeholder="请输入内容"
                                :trigger-on-focus="false"
                                @select="handleSelect"
                            >
                            </el-autocomplete>
                        </div>
                        <img src="../assets/search-icon.png" v-if="!searchShow" @click="searchBox" alt="">
                        <img src="../assets/search-close-icon.png" v-else @click="searchBox" alt="">
                    </div>
                </div>
            <!-- 试乘试驾二级页面 -->
              <div :class="['foxbase-nav', activeUrl === '6' ? 'act' : '']">
                <div class="item" @click="subscribeBtn(1)" :class="subscribeActive == 1 ? 'acts' : ''">
                  <span class="txt">门店查询</span>
                </div>
                  <div class="item" @click="subscribeBtn(2)" :class="subscribeActive == 2 ? 'acts' : ''">
                  <span class="txt">预约试驾</span>
                </div>
                <div class="item" @click="subscribeBtn(3)" :class="subscribeActive == 3 ? 'acts' : ''">
                  <span class="txt">片区招商</span>
                </div>
              </div>
            </div>
            <!-- 下拉 -->
            <div class="headselect" :class="{'auto-height':activeUrl == 3,'auto-height-close':SelectShow == false}">
                <img src="@/assets/shang.png" class="close-img" alt="" width="40px" @click="headSelectShow">
                <el-tabs v-model="activeName" class="drop-down-nav">
                    <el-tab-pane :name="item.class_name" v-for="(item,index) in dataEdetails.datalist" :key="index">
                        <span slot="label" class="nav-title" @mouseenter="mouseIn(item.class_name)">
                            <img class="nav-img" :src="item.class_image" alt="">
                            <span class="nav-text">{{item.class_name}}</span>
                        </span>
                        <el-tabs v-if="item.class_list.length>0" v-model="contentActiveName" tab-position="left" class="drop-down-content animate__animated animate__fadeIn animate__slow">
                            <el-tab-pane :name="idx1+''" v-for="(item1,idx1) in item.class_list" :key="idx1" class="animate__animated animate__fadeIn animate__slow">
                                <span slot="label" @mouseenter="mouseIn1(idx1)" class="content-title animate__animated animate__fadeIn animate__slow">
                                    <span class="content-text">{{item1.pro_name}}</span>
                                    <img class="content-img" :src="item1.top_drop_down_img" alt="">
                                </span>
                                <div class="content-imgDetails animate__animated animate__fadeIn" @click="topath(item1.lead_product_id)">
                                    <img class="content-imgMax" :src="item1.top_drop_down_img" alt="">
                                    <div class="content-pricedetails">
                                        <div class="content-plate">{{item1.pro_name}}</div>
                                        <!-- <div class="content-price">官方建议零售价：<span>￥{{item1.price}}</span></div> -->
                                    </div>
                                </div>
                            </el-tab-pane>
                        </el-tabs>
                        <el-empty v-else description="暂无数据" style="height:555px;"></el-empty>
                    </el-tab-pane>
                </el-tabs>
            </div>
            <!-- 悬浮窗 -->
            <div v-if="this.$route.path != '/'&&this.$route.path != '/arbitrary'" class="float-box" :class="{'auto-height':(this.$route.path == '/'||this.$route.path == '/arbitrary')}">
<!--                <el-popover placement="left" trigger="hover" >-->
<!--                    <div class="detail-ewm">-->
<!--                        <img src="@/assets/cxws.png" alt="">-->
<!--                        <p style="text-align: center;">扫码下载</p>-->
<!--                    </div>-->
<!--                    <div class="ewm-box" slot="reference" @mouseenter="actEwm" @mouseleave="notActEwm">-->
<!--                        <img v-if="mouseAct==false" src="@/assets/last-act-ewm.png" alt="">-->
<!--                        <img v-else src="@/assets/act-ewm.png" alt="">-->
<!--                        <p>行车卫士</p>-->
<!--                    </div>-->
<!--                </el-popover>-->

                <el-popover placement="left" trigger="hover" >
                    <div class="detail-ewm">
                        <img src="@/assets/vgjc.png" alt="">
                        <p style="text-align: center;">扫码下载</p>
                    </div>
                    <div class="ewm-box" slot="reference" @mouseenter="actEwm1" @mouseleave="notActEwm1">
                        <img v-if="mouseAct1==false" src="@/assets/last-act-ewm.png" alt="">
                        <img v-else src="@/assets/act-ewm.png" alt="">
                        <p>无极机车</p>
                    </div>
                </el-popover>
                <!-- 返回顶部 -->
                <el-backtop :right="0" :bottom="0">
                    <div class="topbtn">
                        <svg t="1657100764200" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3013" width="32" height="32"><path d="M955.22334297 449.25694963L560.2638849 54.29749156a80.43980815 80.43980815 0 0 0-60.32985611-24.93634051 80.43980815 80.43980815 0 0 0-57.91666189 23.32754436L67.16786089 431.56019185a80.43980815 80.43980815 0 0 0 113.4201295 113.42012948l238.10183214-240.51502636V914.1990408a80.43980815 80.43980815 0 1 0 160.87961632 0V310.90047962L833.75923265 568.30786571a80.43980815 80.43980815 0 0 0 119.05091606-119.05091608z" fill="#facc0a" p-id="3014"></path></svg>
                    </div>
                </el-backtop>
            </div>
        </div>
    </div>
</template>
<script>
import bus from "@/utils/bus";
import { getProductsDropDownApi, searchApi } from "../../request/api";
export default {
    data() {
        return {
            mouseAct1:false,
            mouseAct:false,
            activeName:'巡航太子系列',
            contentActiveName:'0',
            searchShow:false,
            inputVal:'',
            dataList: [
                {
                    id: '1',
                    name: '首页',
                    url: '/',
                }, {
                    id: '2',
                    name: '品牌故事',
                    url: '/brand-story',
                }, {
                    id: '3',
                    name: '产品世界',
                    url: '/arbitrary',
                }, {
                    id: '4',
                    name: '新闻潮汛',
                    url: '/news-tidal',
                }, {
                    id: '5',
                    name: '无极服务',
                    url: '/warranty-coverage',
                }, {
                    id: '6',
                    name: '预约品鉴',
                    url: '/test-drive',
                }
            ],
            /* 下拉列表 */
            dataEdetails:{
                datalist:[],
            },
            dataActive:1,
            contentActive:1,
            SelectShow:false,
            activeUrl: localStorage.getItem('activeNum') || 1,
            language: 'zh',
            newsActive:1,
            serveActive:1,
            subscribeActive:localStorage.getItem('activeNum2') || 1,
            tabsShow:false,
            tabsShowRight:false,
            searchList:[]
        }
    },
    watch:{
        $route(to,from){
            bus.$on('actNum', (data) => {
                this.activeUrl = data
                localStorage.setItem('activeNum',this.activeUrl)
            })
            if (to.path == '/arbitrary') {
                this.SelectShow = true
            }
        },
    },
    created(){
        this.getProductsDropDownApi()
    },
    mounted(){
        // 点击空白页关闭下拉点击事件
        document.addEventListener("click", this.bodyCloseMenus);
    },
    methods: {
        // 搜索带出搜索建议
        querySearch(queryString, cb){
            const params = {
                m:'Mobile',
                c:'MajorProduct',
                a:'get_product_id_list',
                pro_name:queryString
            }
            searchApi(params).then(({data})=>{
                this.searchList = data.datas.list
                this.searchList.forEach((item,idx) => {
                    item.value = item.pro_name
                });
                cb(data.datas.list.length>0 ? this.searchList : [{value:'暂无数据'}]);
            })
        },
        // 点击搜索建议触发搜索
        handleSelect(item){
            if (item.lead_product_id) {
                this.$router.push({
					path:"/motorbike-details",
					query:{id:item.lead_product_id}
				})
                this.$router.go(0)
            }
        },
        // 下拉弹窗数据
        getProductsDropDownApi(){
            const params = {
                m:'Mobile',
                c:'MajorProduct',
                a:'production_class_list',
                lang:1
            }
            getProductsDropDownApi(params).then(({data})=>{
                this.dataEdetails.datalist = data.datas.info
                if (this.dataEdetails.datalist.length > 0){
                  this.activeName = this.dataEdetails.datalist[0].class_name
                }
            })
        },
        actEwm(){
            this.mouseAct = true
        },
        notActEwm(){
            this.mouseAct = false
        },
        actEwm1(){
            this.mouseAct1 = true
        },
        notActEwm1(){
            this.mouseAct1 = false
        },
        // 点击空白页关闭下拉
        bodyCloseMenus(){
            if (this.SelectShow == true) {
                this.SelectShow = false
            }
        },
        // 搜索框弹出/隐藏
        searchBox(){
            this.searchShow = !this.searchShow
        },
        //跳转详情
        topath(params){
            this.$router.push({
                path:"/motorbike-details",
                query:{id:params}
			})
            this.SelectShow = false
        },
        // logo跳转首页
        toHome(){
            if (this.$route.path == '/') {
                this.$router.go(0)
                this.activeUrl = 1
            }else{
                this.$router.push('/')
                this.activeUrl = 1
            }

        },
        // 点击导航跳转对应页面
        linkto(url, id) {
            this.activeUrl = id
            localStorage.setItem('activeNum',this.activeUrl)
            this.$router.push({path:url})
            if (this.activeUrl == 6) {
                this.subscribeActive = 1
            }
        },
        //
        serhover(id) {
            if (id == 3 && this.$route.path=="/arbitrary") {
                this.SelectShow = true
            }
        },
        // 预约试驾
        subscribeBtn(id){
            this.subscribeActive = id
            localStorage.setItem('activeNum2',this.subscribeActive)
            if(id == 1){
                this.$router.push({path:'/shop'})
            }else if(id == 2){
                this.$router.push({path:'/test-drives'})
            }else if(id == 3){
                this.$router.push({path:'/tojoin-list'})
            }
        },
        // 关闭下拉
        headSelectShow(){
            this.SelectShow = false
        },
        // 鼠标进入顶部list
        mouseIn(val){
            this.activeName = val
            this.contentActiveName = '0'
        },
        // 鼠标进入左边list
        mouseIn1(val){
            this.contentActiveName = val.toString();
        },
    },
    beforeDestroy() {
        document.removeEventListener("click", this.bodyCloseMenus);
    },
}
</script>
<style lang="scss">
.head-text{
  .el-icon-arrow-left{
    font-size: 20px !important;
    color: #4b3c01 !important;
  }
  .el-icon-arrow-left:before{
    content: "\e792" !important;
  }
  .el-icon-arrow-right{
    font-size: 20px !important;
    color: #4b3c01 !important;
  }
  .el-icon-arrow-right:before{
    content: "\e791" !important;
  }
}

.detail-ewm{
    background-color: #facc0a;
    padding: 10px;
    border-radius: 12px;
    color: #000;
}
.el-popper[x-placement^=left] .popper__arrow::after{
    display: none;
}
.el-popover{
    background: none;
    box-shadow: none;
    border:none;
}
.head-text{
    position: absolute;
    width: 100%;
    height: 120px;
    left: 0;
    top: 0;
    z-index: 999;
    background: url("../assets/head-top.png") no-repeat;
    background-size: 100% 100%;
    opacity: 1;
    .head-row {
        width: 1200px;
        margin: 0 auto;
        margin-top: 10px;
        display: flex;
        justify-content: space-between;
        position: relative;
        .head-logo {
            cursor: pointer;
            width: 62px;
            height: 69px;
            img {
                width: 100%;
                height: 100%;
            }
        }
        .navigation {
            width: calc(100% - 133px);
            display: flex;
            align-items: center;
            position: relative;
            justify-content: space-between;
            .navigation-heng {
                width: 1100px;
                height: 1px;
                background: #ffffff;
                position: absolute;
                bottom: 13px;
                left: -25px;
            }
            .data-url {
                display: flex;
                justify-content: space-between;
                // align-items: center;
                width: 700px;
                height: 46px;
                cursor: pointer;
                .data-ulr-details {
                    font-size: 16px;
                    color: #ffffff;
                    position: relative;
                    .data-ulr-details-heng {
                        width: 0px;
                    }
                }
                .data-ulr-details-active {
                    color: #facc0a;
                    // border-bottom: 5px solid #FFF101;
                    border-radius: 2px;
                    z-index: 99;
                    .data-ulr-details-heng {
                        position: absolute;
                        width: 64px;
                        height: 5px;
                        background: #facc0a;
                        left: calc(50% - 32px);
                        bottom: 0;
                        transition: width 0.5s;
                    }
                }
            }
        }
        .language {
            margin-left: 100px;
            display: flex;
            justify-content: center;
            height: 40px;
            font-weight: bold;
            color: #ffffff;
            cursor: pointer;
            .language-active {
                color: #facc0a;
            }
        }
        .icon-row {
            // margin-left: 80px;
            display: flex;
            height: 40px;
            width: 60px;
            transition: 0.5s;
            justify-content: flex-end;
            &.auto{
                width: 300px;
                justify-content: flex-end;
            }
            cursor: pointer;
            img {
                width: 22px;
                height: 22px;
                margin-right: 20px;
            }
            .input-box{
                overflow: hidden;
                position: relative;
                top: -10px;
                margin-right: 20px;
            }
            .el-input__inner{
                background-color: transparent;
                color: white;
            }
            .el-input.is-active .el-input__inner, .el-input__inner:focus{
                border-color:white
            }
        }
        .foxbase-nav {
          display: flex;
          align-items: stretch;
        //   justify-content: center;
          position: absolute;
          overflow: hidden;
          bottom: 20px;
          width: 100%;
          height: 0;
          transition: transform .3s ease-out;
          &.act {
            bottom: 0;
            height: 40px;
            transform: translateY(100%);
          }
          .item {
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0 132px;
            cursor: pointer;
            min-width: 64px;
            .txt {

              font-size: 14px;
              color: #fff;
            }
            &.acts {
              .txt {

                font-size: 16px;
                color: #FFF101;
                font-weight: bold;
                transition: font-size .3s;
              }
            }
          }
        }
    }
    .headselect{
        background: url("../assets/img/arbitrary/arbitrary-bg.jpg") center;
        background-size: 100% 100%;
        overflow: hidden;
        width: 100%;
        height: 0px;
        transition: 0.5s;
        margin: 0 auto;
        top: 94px;
        z-index: 9999;
        &.auto-height{
            height: 684px;
        }
        &.auto-height-close{
            height: 0;
        }
        .close-img{
            float: right;
            position: relative;
            top: 20px;
            right: 20px;
        }
        .drop-down-nav{
            padding: 0 80px;
            .nav-title{
                width: 100%;
                display: flex;
                justify-content: space-around;
                align-items: center;
                .nav-text{
                    padding: 0 10px;
                }
                .nav-img{
                    width: 80px;
                    height: 52px;
                }
            }
            .el-tabs__active-bar{
                display: none !important;
            }
            .el-tabs__nav{
                float: none;
                display: flex;
                justify-content: space-between;
                align-items: center;
            }
            .el-tabs__item{
                padding: 0;
                height: 80px;
                width: 400px;
                display: flex;
                align-items: center;
                position: relative;
                &.el-tabs__item:not(:last-child)::after{
                    content: '';
                    position: absolute;
                    width: 1px;
                    height: 50px;
                    right: 0px;
                    background-color: rgb(158, 158, 158);
                }
                &.el-tabs__item:hover{
                    background-color: #facc0a;
                    color: black;
                    font-weight: 800;
                }
                &.is-active{
                    color: black;
                    background-color: #facc0a;
                    font-weight: 800;
                }
            }
            .el-tabs__nav-wrap::after{
                height: 1px;
                background-color:rgb(158, 158, 158)
            }
        }
        .drop-down-content{
            height: 555px;
            .content-imgDetails{
                cursor: pointer;
                .content-imgMax{
                    width: 650px;
                }
            }
            .el-tabs__nav{
                float: none;
                display: block;
            }
            .content-title{
                width: 100%;
                display: flex;
                justify-content: space-between;
                .content-text{
                    padding: 0 10px;
                    line-height: 69px;
                }
                .content-img{
                    width: 102px;
                    height: 68px;
                }
            }
            .el-tabs__content,.el-tab-pane{
                height: 100%;
            }
            .el-tab-pane{
                display: flex;
                justify-content: center;
                align-items: center;
            }
            .content-pricedetails{
                margin-top: 20px;
                display: flex;
                flex-direction: column;
                align-items: center;
                .content-plate{
                    font-size: 50px;
                }
                .content-price{
                    font-size: 20px;
                    span{
                        color: red;
                    }
                }
            }
            .el-tabs__item{
                padding: 0 20px;
                height: 100px;
                width: 550px;
                display: flex;
                align-items: center;
                position: relative;
                border-bottom: 1px solid rgb(158,158,158);
                &.el-tabs__item:not(:last-child)::after{
                    content: '';
                    position: absolute;
                    width: 0px;
                    height: 0px;
                    right: 0px;
                    background-color: rgb(158, 158, 158);
                }
                &.el-tabs__item:hover{
                    background-color: #facc0a;
                    color: black;
                    font-weight: 800;
                }
                &.is-active{
                    color: black;
                    background-color: #facc0a;
                    font-weight: 800;
                }
            }
        }
    }
    .float-box{
        position: fixed;
        right: 0;
        top: 60vh;
        height: 320px;
        transition: 1s;
        &.auto-height{
            height:210px;
        }
        .topbtn{
            height: 100%;
            width: 100%;
            text-align: center;
            line-height: 60px;
            box-shadow: none;
            display: flex;
            align-items: center;
            flex-direction: column;
            justify-content: center;
        }
        .el-backtop{
            display: block !important;
            width: 80px;
            height: 80px;
            position: relative;
            box-shadow:none;
            -webkit-box-shadow:none;
            border-radius:0;
            background-color: #00000080;
        }
        .ewm-box{
            margin-bottom: 10px;
            width: 80px;
            height: 80px;
            background-color: #00000080;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            img{
                width: 50%;
                height: 50%;
            }
            p{
                color: #fff;
                margin-top: 5px;
            }
        }
        .ewm-box:hover{
            background-color: #facc0a;
            p{color: #000;}

        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/BaseHead.vue